export default __webpack_public_path__ + "static/media/background.c8990c87.jpg";